<template>
    <div class="input-wrapper">
        <input
            :placeholder="placeholder"
            v-model="value"
            type="text"
            @blur="blurInput"
            @focus="focusInput"
            @keypress="keyPressHandler"
            @input="inputChange"
        />
        <DeleteIcon class="input-delete-icon" @iconClick="iconClick" v-show="showIcon" />
    </div>
</template>

<script>
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";

export default {
    name: "IconInput",
    props: ["placeholder", "initValue"],
    components: {
        DeleteIcon
    },
    data() {
        return {
            value: this.initValue || "",
            hasShowIcon: false
        };
    },
    watch: {
        initValue(newVal) {
            this.value = newVal;
        }
    },
    computed: {
        showIcon() {
            return this.hasShowIcon && this.value != "";
        }
    },
    methods: {
        iconClick() {
            this.value = "";
            this.$emit("inputChange", this.value);
        },
        blurInput() {
            this.$emit("inputBlur");
            setTimeout(() => {
                this.hasShowIcon = false;
            }, 300);
        },
        focusInput() {
            this.hasShowIcon = true;
            this.$emit("inputFoucs");
        },
        inputChange() {
            this.$emit("inputChange", this.value);
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.$emit("confirmPress", this.value);
        }
    }
};
</script>

<style scoped lang="less">
.input-wrapper {
    position: relative;
    width: 200px;
    height: 32px;
    border-top: 1px solid #d8e4f0;
    box-sizing: border-box;
    input {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        color: #41475e;
        font-size: 12px;
        outline: none;
        border: 1px solid #fafbfd;
        text-indent: 8px;
        background: #fff;
        padding-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: 4px;
        vertical-align: top;
        &:focus {
            border: 1px solid #2088f3;
        }
    }
    .input-delete-icon {
        position: absolute;
        right: 8px;
        top: 6px;
    }
}
</style>
